import { render, staticRenderFns } from "./WincareOldListComponent.vue?vue&type=template&id=31fd316a"
import script from "./WincareOldListComponent.vue?vue&type=script&lang=js"
export * from "./WincareOldListComponent.vue?vue&type=script&lang=js"
import style0 from "./WincareOldListComponent.vue?vue&type=style&index=0&id=31fd316a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports